import React, {useState, useRef} from 'react'
import Sidebar from "../../components/sidebar/Sidebar";
import "../../styles/sidebar/sidebar.css";
import Header from "../../components/header/Header";
import RecordedDataComponent from '../../components/recordedData/RecordedDataComponent';

const AdminApproveUsers = () => {
    return (
        <>
        <div className="recorded-data-container">
                <Sidebar role="admin"/>
            <div className="main-content">
                <Header/>
                <RecordedDataComponent role="admin-pending"  adminPending={true} title="PENDING USERS" placeholder="Search account user"/>
            </div>
        </div>
        </>
      )
}

export default AdminApproveUsers;